












import Vue from 'vue';
import Component from 'vue-class-component';
import { User } from '@/store';

@Component({})
class Error404 extends Vue {
  @User.State('project') project;
}

export default Error404;
